export const util = {
    array_object(arr) {
        let obj = [...arr.entries()].reduce((obj, [key, value]) => (obj[key] = value, obj), {});
        return obj;
    },
    array_valores(arr, prop) {
        var A=arr;
        if (typeof(arr)==='object') { // pasamos a array
            A=this.object_array(arr);
        }
        return A.map(function(e) { return e[prop]; }).filter(function(e,i,a){
            return i === a.indexOf(e);
        }).sort();
    },
    object_array(obj) {
        let result=Object.keys(obj).map(function(key) {
            return obj[key];
        });
        return result;
    },
  
}